export class BannerSlider {

  public bannerSliderID: number;
  public Id: number;
  public type: string;
  public venderID: number;
  public isActive: boolean;
  public brandID: number;
  public bannerSliderImages: string;
  public sliderFor: string;
  public webMobile: string;
  public categoryID: number;
  public brandName: string;
  public categoryName: string;
  public image: string;
  public imagecount: number;
  public sort: string;
  public BannerSliderImages: Array<BannerSliderImageModel>;
}
export class BannerSliderImageModel {
  public Id: number;
  public BannerSliderImageID: any;
  public BannerSliderID: any;
  public ImagePath: any;
  public SortOrder: any;
  public url: string;
}



// WEBPACK FOOTER //
// ./src/app/models/BannerSlider/BannerSlider-model.ts